// extracted by mini-css-extract-plugin
export var searchHeader = "_91-0";
export var searchHeaderDark = "_91-1";